/**
 * Application configuration constants
 */

// Base API URL - should match REACT_APP_API_URL environment variable
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Base URL without /api suffix for static assets
export const BASE_URL = API_BASE_URL.replace(/\/api$/, '');

/**
 * Helper function to construct static asset URL
 * @param {string} path - Asset path (e.g., '/uploads/thumbnail.jpg')
 * @returns {string} Full URL to static asset
 */
export const getStaticUrl = (path) => {
  if (!path) return '';
  // If path is already a full URL, return as is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  // Ensure path starts with slash
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${BASE_URL}${normalizedPath}`;
};